import {
  Component,
  computed,
  EventEmitter,
  input,
  Output,
} from '@angular/core';
import { WorkOrderActionsGRPCService } from '../../../ProxyServices/workorderactions.grpc.service';
import { WorkorderGRPCService } from '../../../ProxyServices/workorder.grpc.service';
import { WorkOrderBase } from '../../../CommonFiles/BusinessModels';
import { WOStatusWeb } from '../../../constants/woStatusOptions';
import { faPause } from '@fortawesome/pro-regular-svg-icons';
import { lastValueFrom, take } from 'rxjs';

@Component({
  standalone: false,
  selector: 'app-hold-popup',
  templateUrl: './holdpopup.component.html',
  styleUrls: ['./holdpopup.component.scss'],
})
export class HoldPopUpComponent {
  faPause = faPause;
  public woInBlackOut = false;
  public holding: boolean;
  showHoldPopup: boolean = false;
  selectedWorkOrders = input<WorkOrderBase[]>([]);
  enableHoldButton = computed<boolean>(() => {
    const selectedWorkOrders = this.selectedWorkOrders();
    return (
      selectedWorkOrders.length > 0 &&
      selectedWorkOrders
        .map((x) => x.StatusWeb)
        .every(
          (x) =>
            x !== WOStatusWeb.CSRHold &&
            x !== WOStatusWeb.Completed &&
            x !== WOStatusWeb.ReturnToUtility &&
            x !== WOStatusWeb.UTC &&
            x !== WOStatusWeb.UtilityCancel &&
            x !== WOStatusWeb.UtilityHold &&
            x !== WOStatusWeb.AwaitingAppointment  
        )
    );
  });
  selectedWOIDs = computed<string[]>(() => {
    return this.selectedWorkOrders().map((x) => x.name);
  });

  @Output() onCloseHoldPopup: EventEmitter<void> = new EventEmitter<void>();

  constructor(
    public _clientWO: WorkorderGRPCService,
    private _client: WorkOrderActionsGRPCService
  ) {
  }

  public checkAndCloseForm(e) {
    this.onCloseHoldPopup.emit(e);
    this.showHoldPopup = false;
  }

  public onSave() {
    this._client.hold(this.holding, this.selectedWOIDs()).subscribe((x) => {
      this.updateStatusAndEmit(x);
      this._clientWO.RXselectedWOIDsShared.next([]); //unselect prev selected points
    });
  }

  private async updateStatusAndEmit(x: any) {
    const selectedWOs = await lastValueFrom(
      this._clientWO.RXselectedWOIDsShared.pipe(take(1))
    );
    const WOSuccessBase: WorkOrderBase[] = x
      .getSuccessWorkOrdersList()
      .map((wo) => {
        const name = wo.getWorkOrderName();
        const matchedWO = selectedWOs.find((woId) => woId.name === name);
        return {
          name,
          FsrIdentifier: this.holding ? matchedWO.FsrIdentifier : null,
          AssignedTo: this.holding ? matchedWO.AssignedTo : null,
          StatusWeb: wo.getStatusWeb(),
          ServiceType: this.holding ? matchedWO.ServiceType : null,
          Audited: null,
          AuditorName: null,
        };
      });
    const WOFailedBase: WorkOrderBase[] = x
      .getFailedWorkOrdersList()
      .map((wo) => {
        const name = wo.getWorkOrderName();
        const matchedWO = selectedWOs.find((woId) => woId.name === name);
        return {
          name,
          FsrIdentifier: this.holding ? matchedWO.FsrIdentifier : null,
          AssignedTo: this.holding ? matchedWO.AssignedTo : null,
          StatusWeb: wo.getStatusWeb(),
          ServiceType: this.holding ? matchedWO.ServiceType : null,
          Audited: null,
          AuditorName: null,
        };
      });
    const WOBase: WorkOrderBase[] = [...WOSuccessBase, ...WOFailedBase];
    this.checkAndCloseForm(WOBase);
  }

  public onHold(hold: boolean) {
    this.holding = hold;

    if (!hold) {
      this.woInBlackOut = this.hasWorkOrderInBlackout();
    }
  }

  private hasWorkOrderInBlackout(): boolean {
    let hasBO = false;
    const workOrderList = this._clientWO.getValue();

    if (workOrderList?.length && this.selectedWOIDs()?.length) {
      for (let x of this.selectedWOIDs()) {
        let l = workOrderList.find((item) => item.name === x);
        hasBO = !!l.InBlackout;
        if (hasBO) {
          break;
        }
      }
    }

    return hasBO;
  }
}
